import { Moon, MonitorSmartphone, Sun } from 'lucide-react';
import { Button, type ButtonSize, type ThemeMode } from '@eombor/ui';
import { nextThemeMode, themeLabel, useThemeMode } from './useThemeMode.js';

const ThemeIcon = ({ mode }: { mode: ThemeMode }) => {
  if (mode === 'light') return <Sun size={16} aria-hidden />;
  if (mode === 'dark') return <Moon size={16} aria-hidden />;
  return <MonitorSmartphone size={16} aria-hidden />;
};

export interface ThemeToggleProps {
  size?: ButtonSize;
  /** `false` — faqat belgi ko'rinadi (kirish sahifasidagi ixcham qator uchun). */
  withLabel?: boolean;
}

/**
 * Temani almashtiradigan yagona tugma. Uchta holat aylanma tartibda keladi;
 * joriy holat nomi tugmaning o'zida yozilgani uchun taxmin qilish kerak emas.
 */
export const ThemeToggle = ({ size = 'sm', withLabel = true }: ThemeToggleProps) => {
  const [mode, setMode] = useThemeMode();

  return (
    <Button
      variant="ghost"
      size={size}
      aria-label={`Tema: ${themeLabel[mode]}`}
      onClick={() => setMode(nextThemeMode[mode])}
    >
      <ThemeIcon mode={mode} />
      {withLabel ? themeLabel[mode] : null}
    </Button>
  );
};
